var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"sliceWrapper",staticClass:"wrapper",class:{'tourActive': _vm.tourCurrentStep >= 0 && (_vm.tourCurrentTarget === '#sliceWrapper')},attrs:{"id":"sliceWrapper"}},[_c('canvas',{ref:"sliceCanvas",attrs:{"id":"sliceCanvas"}})])}
var staticRenderFns = []

export { render, staticRenderFns }